
import { defineComponent } from 'vue'
import ChatWidget from '@/frontend/components/ChatWidget.vue'

export default defineComponent({
  name: 'App',
  components: {ChatWidget}
})
